export default "__VITE_ASSET__CRhIdKrU__"